import React, { memo } from 'react';
import RentReportingActiveCard from './RentReportingActiveCard';
import RentReportingEmptyCard from './RentReportingEmptyCard';
const RentReportingCard = ({ data, emptyCardButtonBrandReversed, }) => data ? (<RentReportingActiveCard data={data}/>) : (<RentReportingEmptyCard buttonBrandReversed={emptyCardButtonBrandReversed}/>);
export default memo(RentReportingCard);
